import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUnassignCarrierPrompt extends Layout {
    advanceCarriersLabel: Label;
    labelMulti: Label;
    labelSingle: Label;
    panelReason: Panel;
    sourceExtraPay: DataSource;
    textboxComments: Textbox;
    textboxReasonCode: Textbox;
}
